// src/pages/BillingCancel.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function BillingCancel() {
  const navigate = useNavigate();

  useEffect(() => {
    const id = setTimeout(() => navigate("/pricing"), 1200);
    return () => clearTimeout(id);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F0F1B] via-[#121225] to-[#15152B] px-4">
      <div className="w-full max-w-md rounded-3xl border border-[#FC2783]/30 bg-[#15152B]/90 shadow-[0_0_60px_rgba(252,39,131,0.25)] p-8 text-center">
        <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-amber-400/10 px-4 py-1 text-xs font-medium uppercase tracking-[0.16em] text-amber-200">
          <span className="h-2 w-2 rounded-full bg-amber-400 animate-pulse" />
          Payment cancelled
        </div>

        <div className="mb-4 text-5xl">🧾</div>

        <h1 className="text-2xl font-semibold text-white mb-2">
          Checkout Cancelled
        </h1>

        <p className="text-sm text-gray-300 mb-1">
          No worries — you were not charged.
        </p>
        <p className="text-xs text-gray-400">
          Redirecting you back to{" "}
          <span className="font-medium text-[#FC2783]">Pricing</span>…
        </p>

        <div className="mt-6 h-px w-16 mx-auto bg-gradient-to-r from-transparent via-[#FC2783] to-transparent" />

        <button
          onClick={() => navigate("/pricing")}
          className="mt-5 inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold text-white border border-[#2A2A40] bg-[#1C1C2E] hover:scale-[1.01] hover:shadow-xl hover:ring-1 hover:ring-pink-500/30 transition"
        >
          Go to Pricing
        </button>
      </div>
    </div>
  );
}
